import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {useDispatch, useSelector} from 'react-redux';

import {createConversation, getMessageTypes} from '../../actions/admin/header/messageActions';
import {getAllUsersByCLients} from "../../actions/admin/userManagementActions";
import {clearFileUploads} from "../../actions/fileUploadActions";
import {Typeahead} from "react-bootstrap-typeahead";
import {Button} from '../../components/buttons';
import Spinner from 'react-bootstrap/Spinner';
import {useAuth} from "../../context/authContext";
import {FileUpload} from '../../components/FileUpload';

const componentName = "ComposeMessage";

const ComposeMessage = ({ closeModal }) => {
    const auth = useAuth();
    const token = auth.getAuthToken();
    const [emailData, setEmailData] = useState({});
    const [msgType, setMsgType] = useState({});
    const handleChangeWithinModal = (e) => {
        const { name, value } = e.target;
        setEmailData({
            ...emailData,
            [name]: value,
        });
        isFormValid();
    };
    const handleUploadFileChange = (arr) => {
        setUploadedFiles(arr);
    };

    const { allUsers } = useSelector((state) => state.userManagement);
    const { messageTypes } = useSelector((state) => state.messages);
    const dispatch = useDispatch();
    const [users, setUsers] = useState([]);
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [urgent, setUrgent] = useState(false);

    const handleChange = (e) => {
        if (e.length === 0) {
            setMsgType([]);
        } else {
            setMsgType(e[0]);
        }
        isFormValid();
    };

    const createConvAndSend = async () => {
        let userId = auth.getUserId();
        const converseMessage = {
            conversationDto: {
                title: emailData.title,
                participants: [...users, userId],
                messageType: msgType,
            },
            messageDto: {
                title: emailData.title,
                message: emailData.message,
                messageType: msgType,
                important: urgent,
            },
        };
        if (uploadedFiles?.length) {
            converseMessage.messageDto["uploadedFiles"] = uploadedFiles;
        }
        Promise.resolve(dispatch(createConversation(converseMessage))).then(onModalClose);
    };

    const updateUsers = (e) => {
        setUsers(e.map((user) => user.id));
    };

    useEffect(() => {
        function fetchData() {
            if (!messageTypes?.length) {
                dispatch(getMessageTypes(token));
            }
        }
        fetchData();
    }, [dispatch, messageTypes.length, token]);

    const isFormValid = () => {
        const { title, message } = emailData;
        const hasMessageType = Array.isArray(msgType)
            ? msgType.length > 0
            : Object.keys(msgType || {}).length > 0;
        return !(
            title &&
            hasMessageType &&
            message &&
            users &&
            title.length &&
            message.length &&
            users.length
        );
    };

    const onModalClose = () => {
        dispatch(clearFileUploads());
        closeModal();
    }

    useEffect(() => {
        function fetchMessages() {
            if (!allUsers?.length) {
                dispatch(getAllUsersByCLients());
            }
        }
        fetchMessages();
    }, [allUsers.length, dispatch]);

    return (
        <>
            {allUsers?.length ? (
                <>
                    <div className="modal-body">
                        <form>
                            <div className="row">
                                <div className="col-12">
                                    <div className="form-group m-b-10">
                                        <label htmlFor={`${componentName}-chooseUsersValue`} id={`${componentName}-chooseUsersLabel`} className="d-block">Choose Users<span className="text-danger">*</span></label>
                                        <Typeahead
                                            id={`${componentName}-chooseUsersValue`}
                                            inputProps={{
                                                id: `${componentName}-chooseUsersValue`
                                            }}
                                            multiple
                                            labelKey="email"
                                            onChange={(e) => updateUsers(e)}
                                            options={allUsers}
                                        />
                                    </div>
                                    <div className="form-group m-b-10">
                                        <label htmlFor={`${componentName}-chooseMessageTypesValue`} className="d-block fw-bold">Choose Message Type<span className="text-danger">*</span></label>
                                        <Typeahead
                                            id={`${componentName}-chooseMessageTypesValue`}
                                            inputProps={{
                                                id: `${componentName}-chooseMessageTypesValue`
                                            }}
                                            labelKey="msgType"
                                            onChange={(e) => handleChange(e)}
                                            options={messageTypes}
                                        />
                                    </div>
                                    <div className="form-group m-b-10">
                                        <label htmlFor={`${componentName}-subjectValue`} className="d-block fw-bold">Subject<span className="text-danger">*</span></label>
                                        <input
                                            id={`${componentName}-subjectValue`}
                                            type="text"
                                            onChange={(e) => handleChangeWithinModal(e)}
                                            className="form-control"
                                            name="title"
                                        />
                                    </div>
                                    <div className="form-group m-b-10">
                                        <FileUpload
                                            onChange={handleUploadFileChange}
                                            clearStateProp={0}
                                        />
                                    </div>
                                    <div className="form-group m-b-0">
                                        <label htmlFor={`${componentName}-messageValue`} className="d-block fw-bold">Message<span className="text-danger">*</span></label>
                                        <textarea
                                            id={`${componentName}-messageValue`}
                                            className="form-control"
                                            name="message"
                                            onChange={(e) => handleChangeWithinModal(e)}
                                            rows="5"
                                        ></textarea>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div className="modal-footer">
                        <div className="me-auto">
                            <label className="custom-control custom-checkbox">
                                <input
                                    value={urgent}
                                    type="checkbox"
                                    name="markUrgent"
                                    onClick={() => setUrgent(!urgent)}
                                    className="custom-control-input"
                                />
                                <span className="custom-control-label">Mark As Urgent</span>
                            </label>
                        </div>
                        <Button className="btn" data-dismiss="modal" onClick={() => onModalClose()}>
                            Cancel
                        </Button>
                        <Button
                            className="btn btn-primary"
                            onClick={() => createConvAndSend()}
                            disabled={isFormValid()}>
                            Send
                        </Button>
                    </div>
                </>
            ) : (
                <>
                    <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                    />{" "}
                    Loading...
                </>
            )}
        </>
    );
}

ComposeMessage.propTypes = {
    closeModal: PropTypes.func.isRequired,
};

export default ComposeMessage;
